import * as React from "react";
import { Card, CardContent, Typography } from '@material-ui/core/';

import "./AbstractProduct.scss";

// tslint:disable-next-line:no-empty-interface
export interface IAbstractProductProps {
    img: string;
    name: string;
    url: string;
}

export class AbstractProduct extends React.Component<IAbstractProductProps, any> {
  public render() {
    return (<div>
        <a href={ this.props.url }>
            <Card className="card-products" >
                <img title="Imagem produto" className="card-image" src={ this.props.img } />
                <CardContent className="labelName">
                    <Typography variant="body2"  align="center">
                    { this.props.name }
                    </Typography>
                </CardContent>
            </Card>
        </a>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/products/AbstractProducts/AbstractProduct.tsx